import { gql } from '@apollo/client';

export const GET_PARAMETROS_BY_CONSULTA = gql`
  query consultaFiltros($idConsulta: Int!) {
    consultaFiltros(idConsulta: $idConsulta) {
      idConsultaFiltro
      titulo
      observacion
      esCombo
      parametroSQL
      idTipoDatoNavigation{
        idTipoDato
        valor
      }
    }
  }
`;

export const GET_CONSULTA_COMBO = gql`
  query GetConsultaCombo($idConsultaFiltro: Int!) {
    consultaCombo(idConsultaFiltro: $idConsultaFiltro) {
      valorEsperado {
        valor
        descripcion
      }
    }
  }
`;

export const adaptParametroTipo = (tipoDatoValor) => {
  switch (tipoDatoValor) {
    case 'int':
      return 'float';
    case 'string':
      return 'string';
    case 'date':
      return 'date';
    case 'combo':
      return 'select';
    case 'month':
      return 'month';
    case 'year':
      return 'year';
    default:
      return 'string';
  }
};

export const adaptComboOption = (option) => ({
  id: option.valor,
  displayName: option.descripcion
});

export const adaptParametro = (parametroData, options = []) => {
  const tipo = adaptParametroTipo(parametroData.idTipoDatoNavigation?.valor);

  return {
    id: parametroData.idConsultaFiltro?.toString(),
    displayName: parametroData.titulo,
    name: parametroData.parametroSQL,
    type: tipo,
    required: false,
    options: tipo === 'select' ? options : [],
    idConsultaFiltro: parametroData.idConsultaFiltro,
    esCombo: parametroData.esCombo,
    observacion: parametroData.observacion
  };
};

export const adaptParametrosArray = (parametrosData) => {
  return parametrosData?.map(parametro => adaptParametro(parametro)) || [];
};
